import { useMutation } from '@tanstack/react-query';
import { instance, queryClient } from '@configs';
import { CheckoutQueryKeys } from '@entities/checkout/constants';

import { CalculateCommissionAmountRoute } from './constants';
import { ICalculateCommissionAmount, PaymentOptions } from './types';

export const useCalculateCommissionAmountQuery = () => {
  return useMutation({
    mutationFn: async (params: ICalculateCommissionAmount) => {
      const { data } = await instance.post<PaymentOptions>(
        CalculateCommissionAmountRoute.CalculateCommissionAmount,
        params
      );
      return data;
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: [CheckoutQueryKeys.Checkout] });
    },
  });
};
